import { inApp } from "@/modules/common";
import { Notification } from "@/types/entity";
import { NotifyData } from "@/types/notification";
import { defineStore } from "pinia";
import { watch } from "vue";
import { useGlobalUser } from "./globalUser";
import { standardNotificationItemFactory } from "./notification-utils";

export enum JsBridgeEvent {
  LOGIN_STATUS_CHANGED = "loginStatusChanged",
  LOGOUT = "logout",
  INIT = "init",
  QUIT_APP = "quitApp",
}

export const useJsBridgeStore = defineStore("jsBridge", () => {
  window.onNotificationClick = (n: Notification<NotifyData>) => {
    const item = standardNotificationItemFactory(n);
    item.onClick(window.$router);
  };

  const registerLoginStatusChangedHandler = () => {
    if (!inApp) return;
    const userStore = useGlobalUser();
    watch(
      () => userStore.isLogin,
      (isLogin) => {
        window.flutter_inappwebview?.callHandler(
          JsBridgeEvent.LOGIN_STATUS_CHANGED,
          isLogin,
          userStore.user?.id ?? 0
        );
        console.log("callJsBridgeHandler", isLogin);
      }
    );
  };

  const callLogoutHandler = () => {
    window.flutter_inappwebview?.callHandler(JsBridgeEvent.LOGOUT, null);
  };

  const callInitHandler = () => {
    const userStore = useGlobalUser();
    window.flutter_inappwebview?.callHandler(
      JsBridgeEvent.INIT,
      userStore.isLogin,
      userStore.user.id
    );
  };

  const callQuitAppHandler = () => {
    window.flutter_inappwebview?.callHandler(JsBridgeEvent.QUIT_APP, null);
  };

  return {
    callLogoutHandler,
    registerLoginStatusChangedHandler,
    callInitHandler,
    callQuitAppHandler,
  };
});
